import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import classNames from 'classnames';
export var FadeList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context;

  var items = props.items,
      parentPrefixCls = props.parentPrefixCls,
      needAnimation = props.needAnimation,
      currentIndex = props.currentIndex,
      itemWidth = props.itemWidth;
  var itemRef = React.useRef(null);
  var fadeListPrefixCls = "".concat(parentPrefixCls, "-list-fade");
  var listPrefixCls = "".concat(parentPrefixCls, "-list");

  var renderItems = function renderItems() {
    return _mapInstanceProperty(items).call(items, function (item, index) {
      var opacityClassName = index === currentIndex ? "".concat(listPrefixCls, "-item-not-hidden") : "".concat(listPrefixCls, "-item-hidden");
      var animationClassName = needAnimation ? "".concat(listPrefixCls, "-item-animation") : "".concat(listPrefixCls, "-item-none-animation");
      var posx = -1 * index * itemWidth;
      return /*#__PURE__*/React.createElement("li", {
        className: classNames("".concat(listPrefixCls, "-item"), opacityClassName, animationClassName),
        key: index,
        ref: itemRef,
        style: {
          left: "".concat(posx, "px")
        }
      }, item);
    });
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: _concatInstanceProperty(_context = "".concat(listPrefixCls, " ")).call(_context, fadeListPrefixCls),
    ref: ref
  }, renderItems());
});